<script setup lang="ts">
import { onMounted, ref } from 'vue'
import type { IPlano } from '@/pages/admin/plano/types'
import PlanosGrid from '@/components/planos/PlanosGrid.vue'
import useApi from '@/composables/useApi'

definePage({
  meta: {
    layout: 'landing-page',
    public: true,
  },
})

const planos = ref<IPlano[]>([])
const loading = ref(false)
const router = useRouter()

const fetchPlanos = async () => {
  try {
    loading.value = true
    // Usa o useApi que tem a baseURL configurada corretamente
    // Note: a rota está em /api/landing-page (sem v1)
    const { data } = await useApi.get('/landing-page/listar/planos')
    planos.value = data.data || []
  }
  catch (error) {
    console.error('Erro ao buscar planos:', error)
    planos.value = []
  }
  finally {
    loading.value = false
  }
}

const handleSelectPlano = () => {
  // Verifica se o usuário está logado
  const userData = useCookie('userData').value
  const accessToken = useCookie('accessToken').value
  const isLoggedIn = !!(userData && accessToken)

  if (isLoggedIn) {
    // Se já estiver logado, redireciona para o dashboard
    router.push('/admin')
  }
  else {
    // Se não estiver logado, redireciona para a página de cadastro
    router.push('/admin/auth/cadastrar')
  }
}

onMounted(() => {
  fetchPlanos()
})
</script>

<template>
  <section
    id="pricing-section"
    class="pricing-section"
  >
    <VContainer>
      <div class="pricing-header">
        <div class="text-center mb-10">
          <h2 class="text-h3 font-weight-bold mb-4">
            Nossos Planos
          </h2>
          <p class="text-h6 text-medium-emphasis mx-auto" style="max-width: 600px;">
            Escolha o plano ideal para o seu negócio e comece a gerenciar seus eventos de forma profissional
          </p>
        </div>
      </div>

      <div
        v-if="loading"
        class="d-flex justify-center align-center py-16"
      >
        <VProgressCircular
          indeterminate
          color="primary"
          size="64"
        />
      </div>

      <PlanosGrid
        v-else
        :planos="planos"
        action-button-text="Começar Agora"
        @select-plano="handleSelectPlano"
      />

      <div class="text-center mt-10">
        <p class="text-body-1 text-medium-emphasis mb-4">
          Já tem uma conta?
        </p>
        <VBtn
          variant="outlined"
          color="primary"
          size="large"
          :to="{ name: 'admin-auth-login' }"
        >
          Fazer Login
        </VBtn>
      </div>
    </VContainer>
  </section>
</template>

<style lang="scss" scoped>
.pricing-section {
  padding-block: 5rem;
  background: linear-gradient(180deg, rgba(var(--v-theme-surface), 1) 0%, rgba(var(--v-theme-background), 1) 100%);
}

.pricing-header {
  margin-block-end: 3rem;

  h2 {
    position: relative;
    display: inline-block;
    
    &::after {
      position: absolute;
      background: linear-gradient(90deg, transparent, rgb(var(--v-theme-primary)), transparent);
      block-size: 3px;
      content: "";
      inline-size: 100%;
      inset-block-end: -8px;
      inset-inline-start: 0;
    }
  }
}

@media (max-width: 600px) {
  .pricing-section {
    padding-block: 3rem;
  }
}
</style>


